import React, { useContext, useEffect, useState, useMemo, useCallback } from "react";
import { useSelector } from "react-redux";

import { TableConfig, tableHeaders } from "./IMODCSTableConfig";
import { getIMODCSData } from "../../../../../../services/ChildReportService";
import { emitToasterMsg } from "../../../../../../services/toasterUtility";
import {
	convertLocaltoUTCFormat,
	convertStringtoUTCFormat,
} from "../../../../../../services/DateFormatUtility";
import { Box, Checkbox } from "@mui/material";
import CustomTable from "../../../../../../common/customTable/CustomTable";
import axiosHttp from "../../../../../../services/interceptor";
import { FeatureType } from "../../../../../../constants/FeatureToggles"
import Loader from "../../../../../../common/Loader/Loader";
import { ClaimsContext } from "../../../../../../services/ClaimsService";


export let IMODCSColumnSum = {};

const IMODCSData = () => {

	const {
		userHasClaim,
		userHasFeature,
		userFeaturesAreLoaded,
		fetchUserFeatures,
		checkWcnDelta
	} = useContext(ClaimsContext);

	const [IMODCSData, setIMODCSData] = useState([]);
	const [totalFuelConsumption, setTotalFuelConsumption] = useState(0);
	const [isLoading, setIsLoading] = useState(false);
	const tableHeader = useMemo(() => TableConfig, []);
	const [tableColumn, setTableColumn] = useState(tableHeader);
	
	const [tableColumns, setTableColumns] = useState(tableHeaders);

	const [loading, setLoading] = useState(true);
	const [aggregateFooterData, setAggregateFooterData] = useState({});
	const reportDetails = useSelector(
		(state) => state?.reports?.selectedReportDetails
	);
	
	const reportFlags = useSelector((state) => state.reports.reportFlagDetails);

	const fetchIMODCSData = async () => {
		setLoading(true);
		try {
			setIsLoading(true);
			const IMODCSDataResponse = await getIMODCSData(
				reportDetails.ReportMstId
			);

			const IMODCSResponseData = IMODCSDataResponse?.data?.Data;

			if (
				reportFlags.templateType === "Template2.2:FuelEu" ||
				reportFlags.templateType === "Template2.2"
			) {
				const lastIndexData =
					IMODCSResponseData[IMODCSResponseData.length - 1];
				const removeZeroValues = (lastIndexData) => {
					Object.keys(lastIndexData).forEach((key) => {
						if (
							lastIndexData[key] &&
							typeof lastIndexData[key] === "object"
						) {
							Object.keys(lastIndexData[key]).forEach(
								(subParentKey) => {
									tableHeaders.forEach((element) => {
										if (element.type == "dynamic") {
											if (
												!lastIndexData[
													key
												].hasOwnProperty(
													element.accessor
												)
											) {
												const findIndex =
													tableHeaders.findIndex(
														(a) =>
															a.accessor ==
															element.accessor
													);
												findIndex !== -1 &&
													tableHeaders.splice(
														findIndex,
														1
													);
											}
										}
									});
								}
							);
							removeZeroValues(lastIndexData[key]);
						} else if (
							lastIndexData[key] === 0 &&
							key != "VoyageNumber"
						) {
							IMODCSResponseData.filter((data) => {
								Object.keys(data).forEach((parentKey) => {
									if (parentKey == key) {
										const findIndex =
											tableHeaders.findIndex(
												(a) => a.accessor === key
											);
										findIndex !== -1 &&
											tableHeaders.splice(findIndex, 1);
										delete data[key];
									}
								});
							});
						}
					});
				};
				const cleanedData = { ...lastIndexData };
				//removeZeroValues(cleanedData);
			}

			const AggregateData =
				IMODCSResponseData[IMODCSResponseData?.length - 1];
			setLoading(false);
			setIMODCSData(
				mapNullValuesToZero(
					IMODCSDataResponse?.data?.Data?.slice(0, -1)
				)
			);

			setIsLoading(false);
			IMODCSColumnSum =
				IMODCSResponseData?.length > 1 ? AggregateData : {};
			const summation = sumFuels(AggregateData.GetImoDcsMetadataDict);

			setTotalFuelConsumption(summation);

			const aggregateFooterData = {};

			// Static columns (can be hardcoded or from existing logic)
			aggregateFooterData["CARGO|CARGO_MT"] =
				AggregateData?.GetImoDcsMetadataDict?.["CARGO|CARGO_MT"] ?? 0;

			aggregateFooterData["CARGO|CARGO_TEU"] =
				AggregateData?.GetImoDcsMetadataDict?.["CARGO|CARGO_TEU"] ?? 0;

			aggregateFooterData["CARGO|CARGO_PAX"] =
				AggregateData?.GetImoDcsMetadataDict?.["CARGO|CARGO_PAX"] ?? 0;

			aggregateFooterData["DistanceExcluded"] =
				AggregateData?.DistanceExcluded ?? 0;

			aggregateFooterData["DistanceTravelled"] =
				AggregateData?.DistanceTravelled ?? 0;

			aggregateFooterData["DistanceTravelledUnderWay"] =
			AggregateData?.DistanceTravelledUnderWay ?? 0;

			aggregateFooterData["HoursUnderWay"] =
				AggregateData?.HoursUnderWay ?? 0;

			aggregateFooterData["DirectCo2"] = AggregateData?.DirectCo2 ?? 0;

			setAggregateFooterData(aggregateFooterData);
		} catch (error) {
			setLoading(false);
			setIsLoading(false);
			// emitToasterMsg(
			// 	"error",
			// 	"BDN Summary",
			// 	error?.response?.errorMessage
			// );
		}
	};
	useEffect(() => {
		fetchIMODCSData();
		return () => (IMODCSColumnSum = {});
	}, []);

	useEffect(() => {
		let allColumns = [...tableColumns];
		
		setTableColumns(allColumns);
	}, []);


	const sumFuels = (metadata) => {
		if (!metadata || typeof metadata !== "object") {
			return 0; // Return 0 if metadata is invalid
		}

		return Object.entries(metadata).reduce((sum, [key, value]) => {
			if (key.includes("FUELCONS|0")) {
				sum += Number(value) || 0; // Add only numeric values, default to 0
			}
			return sum;
		}, 0);
	};

	const mapNullValuesToZero = (data) => {
		for (const key in data) {
			if (data[key] === null) {
				data[key] = 0;
			} else if (typeof data[key] === "object" && data[key] !== null) {
				// Recursively check nested objects
				mapNullValuesToZero(data[key]);
			}
		}
		return data;
	};

	const handleImoDcsExportTable = () => {
		const reportMstId = reportDetails?.ReportMstId;
		axiosHttp
			.get(`api/ImoDcs/GetImoDcsExcel`, {
				params: { reportMstId },
				responseType: "blob",
			})
			.then((response) => {
				if (response.status === 200) {
					const contentType = response?.headers["content-type"];
					if (
						contentType ===
						"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
					) {
						const blob = new Blob([response?.data], {
							type: contentType,
						});
						const url = window.URL.createObjectURL(blob);
						const link = document.createElement("a");
						link.href = url;
						link.setAttribute("download", "IMO-DCS-Export.xlsx");
						document.body.appendChild(link);
						link.click();
						emitToasterMsg(
							"success",
							"IMO DCS.xlsx",
							"Exported successfully"
						);
						document.body.removeChild(link);
					} else {
						emitToasterMsg(
							"error",
							"Export All BDN",
							"Unexpected content type received"
						);
					}
				}
			})
			.catch((error) => {
				emitToasterMsg(
					"error",
					"Error Exporting IMO DCS:",
					error?.response?.data?.errorMessage
				);
			});
	};

	const filterColumns = (AggregateData) => {
		let filteredColumns = ["Index"];
		Object.keys(AggregateData).forEach((key) => {
			if (AggregateData[key] !== 0) {
				filteredColumns.push(key);
			}
		});
		setTableColumn(tableColumn);
	};

	const groupDataByCategory = (IMODCSData) => {
		const categories = {};

		// Define static keys to exclude
		const staticKeys = ["CARGO", "JOURNEY"]; // Add the keys that are static

		IMODCSData.forEach((item) => {
			const metadataDict = item.GetImoDcsMetadataDict;

			Object.entries(metadataDict).forEach(([key, value]) => {
				// Skip static keys
				if (staticKeys.some((staticKey) => key.startsWith(staticKey))) {
					return;
				}

				// Handle FUELCONS separately to get the middle part (ME, AE, BOILER, etc.)
				if (key.startsWith("FUELCONS")) {
					const metaDictData = key.split("|")[1]; // Extract ME, AE, BOILER, etc.

					// if (metaDictData !== "0") {
					categories[metaDictData] = categories[metaDictData] || [];
					categories[metaDictData].push({ key, value });
					// }
				} else {
					// Use the first part of the key as the category for other entries
					const category = key.split("|")[0];
					categories[category] = categories[category] || [];
					categories[category].push({ key, value });
				}
			});
		});

		// Remove duplicate entries within each category by 'key'
		for (const category in categories) {
			categories[category] = Array.from(
				new Map(
					categories[category].map((item) => [item.key, item])
				).values()
			);
		}

		return categories;
	};

	// Example usage
	const categories = groupDataByCategory(IMODCSData);

	const IMODCSColumnSums = useMemo(() => {
		if (!IMODCSData || IMODCSData.length === 0) return {};

		// Initialize an object to store sums
		const totals = {};

		// Iterate through the data excluding the last object
		IMODCSData.forEach((item) => {
			const metadata = item.GetImoDcsMetadataDict || {};
			Object.entries(metadata).forEach(([key, value]) => {
				if (!key.includes("JOURNEY")) {
					if (!totals[key]) {
						totals[key] = 0;
					}
					totals[key] += value;
				}
			});
		});

		return totals;
	}, [IMODCSData]);

	const dynamicColumns = useMemo(() => {
		if (!IMODCSData || IMODCSData.length === 0) return [];

		const sampleMetadata = IMODCSData[0]?.GetImoDcsMetadataDict || {};

		return Object.keys(sampleMetadata)
			.filter((key) => !key.includes("JOURNEY"))
			.map((key) => {
				// Split the key by '|' to get all parts
				const keyParts = key.split("|");

				let header;
				if (keyParts.length === 2) {
					// If the key has two parts like FCBOILER|MDO, display "MDO FCBOILER"
					header = `${keyParts[1]} ${keyParts[0]}`;
				} else {
					// If the key has more than two parts, display the last part
					header = keyParts[keyParts.length - 1];
				}

				return {
					header: header, // Use the formatted header
					accessorKey: `GetImoDcsMetadataDict.${key}`,
					enableHiding: false,
					Footer: () => (
						<Box
							className="total-sum align-right"
							title={
								!isNaN(parseFloat(IMODCSColumnSums[key])) &&
								isFinite(IMODCSColumnSums[key])
									? IMODCSColumnSums[key].toString()
									: undefined
							}
						>
							{
								!isNaN(parseFloat(IMODCSColumnSums[key])) &&
								isFinite(IMODCSColumnSums[key])
									? Number(IMODCSColumnSums[key]).toFixed(3) // Ensures numeric value is formatted with 3 decimal places
									: "0.000" // Fallback for non-numeric values
							}
						</Box>
					),
				};
			});
	}, [IMODCSData]);

	return (
		<>
			{/* new Imo dcs table */}
			<div>
				<div className="fuel-consumption-table">
					{loading ? (
						<div className="loader">
							<Loader />
						</div>
					) : (
						<table class="table table-bordered">
							<thead style={{ height: "50px" }}>
								<tr>
									{tableColumns?.map((header) => (
										<th rowSpan={2}>{header.label}</th>
									))}
									{Object.keys(categories).map((consumer) => {
										// Check if the key starts with 'FUELCONS|0|'
										if (consumer === "0") {
											// Get the array of fuel consumption data for this consumer
											const fuelData =
												categories[consumer];

											// Create an array to store the unique fuel types
											const fuelTypes = fuelData.map(
												(item) => item.key.split("|")[2]
											) .filter(Boolean);; // Extract fuel types from key (e.g., "MDO", "MGO", "HFO")

											// Remove duplicates by converting to a Set, then back to an array
											const uniqueFuelTypes = [
												...new Set(fuelTypes),
											];

											// Render each unique fuel type in a separate column header
											return uniqueFuelTypes.map(
												(fuelType, index) => (
													<th
														key={`${consumer}-${fuelType}`}
														rowSpan={2}
													>
														{fuelType + " CONS"}
													</th>
												)
											);
										}
										return null;
									})}

									{Object.keys(categories).map((consumer) => {
										if (consumer === "0") {
											return null; // Skip rendering this <th>
										}
										const fuelData = categories[consumer];
										const fuelTypes = fuelData.map(
											(item) => {
												if (
													item.key.includes(
														"FUELCONS"
													)
												) {
													return item.key.split(
														"|"
													)[2];
												} else {
													return item.key.split(
														"|"
													)[1];
												}
											}
										);
										const uniqueFuelTypes = [
											...new Set(fuelTypes),
										];
										// FUTURE SCOPE
										// return (
										// 	<>
										// 		<th
										// 			key={consumer}
										// 			rowSpan={1}
										// 			colSpan={
										// 				uniqueFuelTypes?.length
										// 			}
										// 		>
										// 			{consumer}
										// 		</th>
										// 	</>
										// );
									})}
								</tr>
								<tr>
									{/* Render fuel types for each non-'0' consumer */}
									{Object.keys(categories).map((consumer) => {
										if (consumer !== "0") {
											const fuelData =
												categories[consumer];

											// Extract fuel types and remove duplicates
											const fuelTypes = fuelData.map(
												(item) => {
													if (
														item.key.includes(
															"FUELCONS"
														)
													) {
														return item.key.split(
															"|"
														)[2];
													} else {
														return item.key.split(
															"|"
														)[1];
													}
												}
											) .filter(Boolean);
											const uniqueFuelTypes = [
												...new Set(fuelTypes),
											];

											return uniqueFuelTypes.map(
												(fuelType) => {
													// Determine if "CONS" needs to be added
													const isFuelCons =
														fuelData.some((item) =>
															item.key.includes(
																"FUELCONS"
															)
														);

													return (
														<th
															key={`${consumer}-${fuelType}`}
														>
															{`${
																consumer ===
																	"FCVOYAGE" ||
																consumer ===
																	"FCBOILER" ||
																consumer ===
																	"FCELECTRICAL" ||
																consumer ===
																	"TFJ" ||
																consumer ===
																	"FCOTHER"
																	? `${fuelType} ${consumer}`
																	: `${consumer} ${fuelType}`
															}`}
															{isFuelCons
																? " CONS"
																: ""}
														</th>
													);
												}
											);
										}
										return null;
									})}
								</tr>
							</thead>
							<tbody>
								{IMODCSData.map((row, rowIndex) => (
									<>
										<tr key={row?.ImoDcsDtlId}>
											<td>{rowIndex + 1}</td>
											<td>
												<Checkbox
													size="small"
													checked={
														row?.IsSampleVoyage
													}
													disabled={
														!row?.IsSampleVoyage
													}
												/>
											</td>
											<td>
												{convertLocaltoUTCFormat(
													new Date(row.StartDateTime)
												)}
											</td>
											<td>
												{convertLocaltoUTCFormat(
													new Date(row.EndDateTime)
												)}
											</td>

											<td>
												{row?.EventType || ""}
											</td>

											<td style={{ textAlign: "right" }}>
												<span
													style={{
														textAlign: "right",
													}}
													title={
														row?.DistanceTravelled ??
														0.0
													}
												>
													{parseFloat(
														row?.DistanceTravelled ??
															0.0
													).toFixed(3)}
												</span>
											</td>

											<td style={{ textAlign: "right" }}>
												<span
													style={{
														textAlign: "right",
													}}
													title={
														row?.DistanceTravelledUnderWay ??
														0.0
													}
												>
													{parseFloat(
														row?.DistanceTravelledUnderWay ??
														0.0
													).toFixed(3)}
												</span>
											</td>

											<td style={{ textAlign: "right" }}>
												<span
													style={{
														textAlign: "right",
													}}
													title={
														row?.HoursUnderWay ??
														0.0
													}
												>
													{parseFloat(
														row?.HoursUnderWay ??
															0.0
													).toFixed(3)}
												</span>
											</td>

											<td style={{ textAlign: "right" }}>
												<span
													style={{
														textAlign: "right",
													}}
													title={
														row
															?.GetImoDcsMetadataDict?.[
															"CARGO|CARGO_MT"
														] ?? 0.0
													}
												>
													{parseFloat(
														row
															?.GetImoDcsMetadataDict?.[
															"CARGO|CARGO_MT"
														] ?? 0.0
													).toFixed(3)}
												</span>
											</td>

											<td style={{ textAlign: "right" }}>
												<span
													style={{
														textAlign: "right",
													}}
													title={
														row
															?.GetImoDcsMetadataDict?.[
															"CARGO|CARGO_TEU"
														] ?? 0.0
													}
												>
													{parseFloat(
														row
															?.GetImoDcsMetadataDict?.[
															"CARGO|CARGO_TEU"
														] ?? 0.0
													).toFixed(3)}
												</span>
											</td>

											<td style={{ textAlign: "right" }}>
												<span
													style={{
														textAlign: "right",
													}}
													title={
														row
															?.GetImoDcsMetadataDict?.[
															"CARGO|CARGO_PAX"
														] ?? 0.0
													}
												>
													{parseFloat(
														row
															?.GetImoDcsMetadataDict?.[
															"CARGO|CARGO_PAX"
														] ?? 0.0
													).toFixed(3)}
												</span>
											</td>

											<td>
												{row?.LadenVoyage === true
													? "Y"
													: "N"}
											</td>
											<td>
												{row?.ExceptionalConditions ===
												true
													? "Y"
													: "N"}
											</td>
											<td>
												{row?.SailingInIce === true
													? "Y"
													: "N"}
											</td>
											<td>
												{row?.STSOperation === true
													? "Y"
													: "N"}
											</td>

											<td style={{ textAlign: "right" }}>
												<span
													style={{
														textAlign: "right",
													}}
													title={
														row?.DistanceExcluded ??
														0.0
													}
												>
													{parseFloat(
														row?.DistanceExcluded ??
															0.0
													).toFixed(3)}
												</span>
											</td>

											{Object.keys(categories).map(										
												(consumer) => {
													if (
														consumer === "0"
													) {
														// Get the fuel data for the current consumer
														const fuelData =
															categories[
																consumer
															];
 
														// Iterate over the unique fuel types for this consumer
														const fuelTypes = fuelData
															.map((item) => {
																if (item.key.includes("FUELCONS")) {
																	return item.key.split("|")[2]; // Fuel type is the 3rd part of the key
																} else {
																	return item.key.split("|")[1]; // Else, use the 2nd part (like CARGO data)
																}
															})
															.filter(
																(fuel) =>
																	fuel &&
																	fuel !== "FCELECTRICAL" &&
																	fuel !== "FCVOYAGE" &&
																	fuel !== "FCBOILER" &&
																	fuel !== "TFJ" &&
																	fuel !== "FCOTHER"
															);
														// Remove duplicates from the fuel types array
														const uniqueFuelTypes =
															[
																...new Set(
																	fuelTypes
																),
															];


														return uniqueFuelTypes.map(
															(fuelType) => {
																 if (!fuelType) return null;

																// Find the value for the current fuel type from the row's metadata
																const fuelValue =
																	row
																		?.GetImoDcsMetadataDict[
																		`FUELCONS|${consumer}|${fuelType}`
																	] || 0;																
																return (
																	<td
																		style={{
																			textAlign:
																				"right",
																		}}
																		key={`${consumer}-${fuelType}`}
																		title={
																			fuelValue ??
																			0.0
																		}
																	>
																		{parseFloat(
																			fuelValue ??
																				0.0
																		).toFixed(
																			3
																		)}
																	</td>
																);
															}
														);
													}
												}
											)}

											{Object.keys(categories).map(
												(consumer) => {													
													if (
															consumer === "0"
													) {
														return null; // Skip rendering fuel data for non-relevant consumers
													}

													// Get the fuel data for the current consumer
													const fuelData =
														categories[consumer];
													// Iterate over the unique fuel types for this consumer
													const fuelTypes =
														fuelData.map((item) => {
															// Get the fuel type dynamically from the key
															const keyParts =
																item.key.split(
																	"|"
																); // Split the key by "|"
															return keyParts[
																keyParts.length -
																	1
															]; // Dynamic last part for fuel type
														}) .filter(Boolean);

													// Remove duplicates from the fuel types array
													const uniqueFuelTypes = [
														...new Set(fuelTypes),
													];

													return uniqueFuelTypes.map(
														(fuelType) => {
															// Dynamically create the key
															const dynamicKey = `${consumer}|${fuelType}`; // Adjust this logic based on your key structure

															// Find the matching key, whether it's FUELCONS or FCVOYAGE or any other type
															const matchedKey =
																Object.keys(
																	row?.GetImoDcsMetadataDict ||
																		{}
																).find((key) =>
																	key.includes(
																		dynamicKey
																	)
																);

															// Retrieve the corresponding value if the matched key is found
															const fuelValue =
																matchedKey
																	? row
																			?.GetImoDcsMetadataDict[
																			matchedKey
																	  ]
																	: 0; // Default to 0 if not found

															return (
																<td
																	style={{
																		textAlign:
																			"right",
																	}}
																	key={`${consumer}-${fuelType}`}
																	title={
																		fuelValue ??
																		0.0
																	}
																>
																	{parseFloat(
																		fuelValue ??
																			0.0
																	).toFixed(
																		3
																	)}
																</td>
															);
														}
													);
												}
											)}
										</tr>
									</>
								))}
							</tbody>

							<tfoot className="footer-container">
								{IMODCSData.length > 0 && (
									<>
										<tr>
											<td></td>
											<td></td>
											<td></td>
											<td></td>
											<td></td>

											<td style={{ textAlign: "right" }}>
												<span
													style={{
														textAlign: "right",
													}}
													title={
														aggregateFooterData[
															"DistanceTravelled"
														] ?? 0.0
													}
												>
													{parseFloat(
														aggregateFooterData[
															"DistanceTravelled"
														] ?? 0.0
													).toFixed(3)}
												</span>
											</td>

											<td style={{ textAlign: "right" }}>
												<span
													style={{
														textAlign: "right",
													}}
													title={
														aggregateFooterData[
															"DistanceTravelledUnderWay"
														] ?? 0.0
													}
												>
													{parseFloat(
														aggregateFooterData[
															"DistanceTravelledUnderWay"
														] ?? 0.0
													).toFixed(3)}
												</span>
											</td>

											<td style={{ textAlign: "right" }}>
												<span
													style={{
														textAlign: "right",
													}}
													title={
														aggregateFooterData[
															"HoursUnderWay"
														] ?? 0.0
													}
												>
													{parseFloat(
														aggregateFooterData[
															"HoursUnderWay"
														] ?? 0.0
													).toFixed(3)}
												</span>
											</td>

											<td style={{ textAlign: "right" }}>
												<span
													style={{
														textAlign: "right",
													}}
													title={
														aggregateFooterData[
															"CARGO|CARGO_MT"
														] ?? 0.0
													}
												>
													{parseFloat(
														aggregateFooterData[
															"CARGO|CARGO_MT"
														] ?? 0.0
													).toFixed(3)}
												</span>
											</td>

											<td style={{ textAlign: "right" }}>
												<span
													style={{
														textAlign: "right",
													}}
													title={
														aggregateFooterData[
															"CARGO|CARGO_TEU"
														] ?? 0.0
													}
												>
													{parseFloat(
														aggregateFooterData[
															"CARGO|CARGO_TEU"
														] ?? 0.0
													).toFixed(3)}
												</span>
											</td>

											<td style={{ textAlign: "right" }}>
												<span
													style={{
														textAlign: "right",
													}}
													title={
														aggregateFooterData[
															"CARGO|CARGO_PAX"
														] ?? 0.0
													}
												>
													{parseFloat(
														aggregateFooterData[
															"CARGO|CARGO_PAX"
														] ?? 0.0
													).toFixed(3)}
												</span>
											</td>

											<td></td>
											<td></td>
											<td></td>
											<td></td>

											<td style={{ textAlign: "right" }}>
												<span
													style={{
														textAlign: "right",
													}}
													title={
														aggregateFooterData[
															"DistanceExcluded"
														] ?? 0.0
													}
												>
													{parseFloat(
														aggregateFooterData[
															"DistanceExcluded"
														] ?? 0.0
													).toFixed(3)}
												</span>
											</td>

											{Object.keys(categories).map(
												(consumer) => {
													if (
														consumer === "0"
													) {
														const fuelData =
															categories[
																consumer
															];
														const uniqueFuelTypes =
															[
																...new Set(
																	fuelData.map(
																		(
																			item
																		) =>
																			item.key.split(
																				"|"
																			)[2]
																	)
																),
															];

														return uniqueFuelTypes.map(
															(fuelType) => {
																const totalFuel =
																	IMODCSData.reduce(
																		(
																			sum,
																			row
																		) => {
																			return (
																				sum +
																				(row
																					?.GetImoDcsMetadataDict[
																					`FUELCONS|${consumer}|${fuelType}`
																				] ||
																					0)
																			);
																		},
																		0
																	);

																return totalFuel !==
																	0 ? (
																	<td
																		style={{
																			textAlign:
																				"right",
																		}}
																		key={`total-${consumer}-${fuelType}`}
																	>
																		{
																			<span
																				title={
																					totalFuel
																				}
																			>
																				{parseFloat(
																					totalFuel
																				).toFixed(
																					3
																				)}
																			</span>
																		}
																	</td>
																) : null;
															}
														);
													}
													return null;
												}
											)}

											{Object.keys(categories).map(
												(consumer) => {
													if (
														consumer === "0"
													) {
														return null; // Skip rendering fuel data for non-relevant consumers
													}

													const fuelData =
														categories[consumer];
													const fuelTypes =
														fuelData.map((item) => {
															const keyParts =
																item.key.split(
																	"|"
																);
															return keyParts[
																keyParts.length -
																	1
															];
														});

													const uniqueFuelTypes = [
														...new Set(fuelTypes),
													];

													return uniqueFuelTypes.map(
														(fuelType) => {
															const dynamicKey = `${consumer}|${fuelType}`;
															const totalFuel =
																IMODCSData.reduce(
																	(
																		sum,
																		row
																	) => {
																		const matchedKey =
																			Object.keys(
																				row?.GetImoDcsMetadataDict ||
																					{}
																			).find(
																				(
																					key
																				) =>
																					key.includes(
																						dynamicKey
																					)
																			);

																		return (
																			sum +
																			(matchedKey
																				? row
																						?.GetImoDcsMetadataDict[
																						matchedKey
																				  ] ||
																				  0
																				: 0)
																		);
																	},
																	0
																);

															return true ? (
																<td
																	style={{
																		textAlign:
																			"right",
																	}}
																	key={`${consumer}-${fuelType}`}
																>
																	<span
																		title={
																			totalFuel
																		}
																	>
																		{parseFloat(
																			totalFuel
																		).toFixed(
																			3
																		)}
																	</span>
																</td>
															) : null;
														}
													);
												}
											)}
										</tr>
									</>
								)}
							</tfoot>
						</table>
					)}
				</div>
				<p
					className="d-flex justify-content-center mt-3"
					title={
						!isNaN(parseFloat(totalFuelConsumption)) &&
						isFinite(totalFuelConsumption)
							? totalFuelConsumption.toString()
							: undefined
					}
				>
					Total Fuel Consumption (MT) :{" "}
					{!isNaN(parseFloat(totalFuelConsumption)) &&
					isFinite(totalFuelConsumption)
						? parseFloat(totalFuelConsumption).toFixed(3)
						: totalFuelConsumption || "0.000"}
				</p>
			</div>
		</>
	);
};
export default IMODCSData;
